import { useMemo, useSyncExternalStore } from 'react';

const IS_SERVER = typeof window === 'undefined';

export function useMediaQuery(query: string, initialState: boolean) {
  const [subscribe, getSnapshot, getServerSnapshot] = useMemo(() => {
    const media = !IS_SERVER ? window.matchMedia(query) : null;

    function subscribe(onStoreChange: any) {
      if (!IS_SERVER) media?.addEventListener('change', onStoreChange);
      return () => {
        if (!IS_SERVER) media?.removeEventListener('change', onStoreChange);
      };
    }

    function getSnapshot() {
      return !IS_SERVER ? media?.matches : initialState;
    }

    const getServerSnapshot = () => initialState;

    return [subscribe, getSnapshot, getServerSnapshot];
  }, [query, initialState]);
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
